document.addEventListener('DOMContentLoaded', function() {
  let sliderAddToCartBtns = document.querySelectorAll('.addtocart__submit:not([disabled])');

  let addTocartItems = () => {
    sliderAddToCartBtns.forEach(btn => {
      if (!btn.classList.contains('event-added')) {
        btn.classList.add('event-added');
        btn.addEventListener('click', async function() {
          btn.disabled = true;
          try {
            let variantId = btn.dataset.variantId;
            let formData = {
              items: [{ id: variantId, quantity: 1 }]
            };

            // Send a POST request to Shopify's /cart/add.js endpoint
            const response = await fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify(formData)
            });

            if (!response.ok) throw new Error('Network response was not ok.');

            const data = await response.json();

            const addToCartLoader = btn.querySelector(".add__to__cart-btn.mobile");
            const loaderShow = btn.querySelector(".bolt__loader");
            addToCartLoader.classList.add("loader-active");
            loaderShow.classList.remove("hide");
            await cartDrawerUpdate();
            addToCartLoader.classList.remove("loader-active");
            loaderShow.classList.add("hide");

          } catch (error) {
            console.error('Error adding item to cart:', error);
          } finally {
            btn.disabled = false;
          }
        });
      }
    });
  };

  addTocartItems();

  let cartDrawerUpdate = async () => {
    try {
      const response = await fetch(`${window.Shopify.routes.root}cart?section_id=cart-drawer`);
      if (!response.ok) {
        throw new Error(`Failed to fetch cart drawer items: ${response.status}`);
      }

      const responseText = await response.text();
      const parser = new DOMParser();
      const html = parser.parseFromString(responseText, "text/html");
      const updatedSection = html.querySelector("cart-drawer");

      renderSections(getSectionsToRender());

      const currentSection = document.querySelector("cart-drawer");
      if (updatedSection && currentSection) {
        currentSection.replaceWith(updatedSection);

        const cartDrawer = document.querySelector('cart-drawer.drawer');
        cartDrawer.classList.add('active');
      } else {
        console.warn("cart-drawer-items section not found in the DOM or response.");
      }
    } catch (error) {
      console.error("Error reloading cart drawer items:", error);
    }
  };

  let fetchCartCount = async () => {
    try {
      const response = await fetch('/cart.js');
      const cartData = await response.json();
      let cartCount = cartData.item_count;
      console.log('Cart Count:', cartCount);
      return cartCount;
    } catch (error) {
      console.error('Error fetching cart count:', error);
    }
  };

  const getSectionsToRender = () => [
    {
      id: 'cart-icon-bubble',
      section: 'cart-icon-bubble',
      selector: '.shopify-section',
    }
  ];

  const renderSections = (sections) => {
    const url = `${window.location.pathname}?sections=${sections.map(s => s.section).join(',')}`;

    fetch(url)
      .then(res => {
        if (!res.ok) throw new Error(`HTTP error: ${res.status}`);
        return res.json();
      })
      .then(data => {
        sections.forEach(({ section, selector }) => {
          const container = document.querySelector("#cart-icon-bubble");
          if (container && data[section]) {
            container.innerHTML = data[section];
          } else {
            console.warn(`Missing section or container: ${section}`);
          }
        });
      })
      .catch(err => console.error('Section update failed:', err));
  };
});
